<template>
<div>
  OBJECT
</div>  
</template>
<script>
export default {
  
  props: {
    findable: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>